import { sendBeacon } from "@helpers/webBeacon"
import { route } from "ziggy-js"
import { AdInteractionType } from "@shared/models/AdInteraction/AdInteraction"
import { AdUnit } from "@shared/models/AdUnit/AdUnit"

export function trackAdUnitIntersection(adUnit: AdUnit) {
  const data = new FormData()
  data.append("ad_unit_id", adUnit.id.toString())
  data.append("type", AdInteractionType.View)

  sendBeacon(route("merchant.ad-interactions.store"), data)
}

export async function trackAdUnitClick(adUnit: AdUnit) {
  const data = new FormData()
  data.append("ad_unit_id", adUnit.id.toString())
  data.append("type", AdInteractionType.Click)

  sendBeacon(route("merchant.ad-interactions.store"), data)
}
